import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import clsx from 'clsx';
import {
  Backdrop, Card, InputBase, List, Typography,
  CircularProgress, IconButton, Chip, 
  Dialog, DialogContent, Slide,
  Divider, CardContent, 
  CardHeader
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import logger from 'src/utils/logger';

// İkonlar
import SearchIcon from '@material-ui/icons/Search';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import CloseIcon from '@material-ui/icons/Close';
import TodayIcon from '@material-ui/icons/Today';
import EventIcon from '@material-ui/icons/Event';
import StarIcon from '@material-ui/icons/Star';
import HistoryIcon from '@material-ui/icons/History';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AccountBoxIcon from '@material-ui/icons/AccountBox';

import axios from 'src/utils/axios';
import { getUser, sc } from 'src/utils/Common';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  root: { width: '100%' },
  headerWrapper: {
    position: 'sticky',
    top: 0,
    zIndex: 10,
    backgroundColor: '#F4F6F8',
    padding: theme.spacing(2, 2, 1, 2),
  },
  pageTitle: { fontSize: '1.6rem', fontWeight: 800, color: '#424242', marginBottom: theme.spacing(1) },
  searchBox: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: '25px',
    padding: '6px 16px',
    border: '1px solid #e0e0e0',
    marginBottom: theme.spacing(2),
    '&:focus-within': { borderColor: '#FF9800' }
  },
  inputInput: { marginLeft: theme.spacing(1), flex: 1, fontSize: '0.9rem' },
  filterScrollContainer: { 
    display: 'flex', 
    overflowX: 'auto', 
    gap: theme.spacing(1), 
    paddingBottom: theme.spacing(1), 
    '&::-webkit-scrollbar': { display: 'none' } 
  },
  chip: { 
    borderRadius: '12px', 
    fontWeight: 700, 
    backgroundColor: '#fff', 
    border: '1px solid #ddd', 
    color: '#424242', 
    minWidth: '100px',
    '& .MuiChip-icon': {
        marginLeft: '8px'
    }
  },
  activeChip: { 
    backgroundColor: '#FF9800 !important', 
    color: '#fff !important', 
    border: 'none',
    '& .MuiChip-icon': {
        color: '#fff !important'
    }
  },
  card: { margin: theme.spacing(0, 0, 0, 0), borderRadius: '20px', border: '1px solid #e0e0e0', overflow: 'hidden', backgroundColor: '#fff' },
  cardHeader: { padding: theme.spacing(2, 2, 1, 2), borderLeft: '5px solid #FF9800', backgroundColor: '#fafafa' },
  customerName: { fontWeight: 800, color: '#424242', fontSize: '1rem' },
  materialItem: { margin: theme.spacing(1.5), padding: theme.spacing(1.5), borderRadius: '16px', backgroundColor: '#fff', border: '1px solid #f0f0f0', display: 'flex', alignItems: 'center' },
  infoBox: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: '#424242', borderRadius: '12px', padding: '8px', marginRight: theme.spacing(2), minWidth: '45px' },
  qtyText: { color: '#FF9800', fontWeight: 800, fontSize: '1.2rem' },
  imgAction: { backgroundColor: '#FF9800', color: '#fff', borderRadius: '12px', padding: 10 },
  backdrop: { zIndex: 2000, color: '#fff' },
  dialogHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#424242', color: '#fff', padding: '8px 16px' },
  previewImg: { maxWidth: '100%', borderRadius: '8px' }
}));

const FILTER_OPTIONS = [
  { value: 'Bugün', label: 'Bugün', icon: <TodayIcon /> },
  { value: 'Yarın', label: 'Yarın', icon: <EventIcon /> },
  { value: 'Öneri', label: 'Öneri', icon: <StarIcon /> },
  { value: 'Hurda', label: 'Eski', icon: <HistoryIcon /> },
  { value: 'Talep', label: 'Talep', icon: <AssignmentIcon /> },
  { value: 'Zimmet', label: 'Zimmet', icon: <AccountBoxIcon /> },
];

function Todos() {
  const classes = useStyles();
  const history = useHistory();
  const [todos, setTodos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [todosData, setTodosData] = useState([]);
  const [stateDurum, setStateDurum] = useState("");
  const [stateGun, setStateGun] = useState("Bugün");

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedImg, setSelectedImg] = useState(null);
  const [imgLoading, setImgLoading] = useState(false);
  const [selectedTitle, setSelectedTitle] = useState("");

  const SessionUser = getUser();
  const BirimKodu = SessionUser.ServiceShopId;
  const TeknisyenKodu = SessionUser.TechnicianId;

  useEffect(() => {
    let isMounted = true;

    axios.get(`/GetArtemisOpenMaterials/${BirimKodu}/${TeknisyenKodu}`).then((res) => {
      if (isMounted) {
        const data = res.data || [];
        setTodos(data);
        setTodosData(data.filter(d => d.GUN === "Bugün"));
        setLoading(false);
      }
    }).catch(error => {
      if (isMounted) setLoading(false);
      logger.error("Material requirement error:", error.message);
    });

    return () => {
      isMounted = false;
    };
  }, [BirimKodu, TeknisyenKodu]);

  useEffect(() => {
    const filtered = todos.filter(item => {
      const matchesSearch = sc(item.FisNo, stateDurum) ||
        item.MALZEMELER.some(m => sc(m.MALZEME_STOK_NO, stateDurum) || sc(m.ACIKLAMA, stateDurum));
      const matchesGun = item.GUN === stateGun;
      return matchesSearch && matchesGun;
    });
    setTodosData(filtered);
  }, [stateDurum, stateGun, todos]);

  const malzemeGosterMI = (code) => {
    setSelectedTitle(code);
    setImgLoading(true);
    setOpenDialog(true);
    axios.post('/FileImportExport/ArtemisMalzeme', { MALZEME_STOK_NO: code }, { responseType: 'blob' })
      .then(res => {
        setSelectedImg(URL.createObjectURL(res.data));
        setImgLoading(false);
      }).catch(() => { setImgLoading(false); setOpenDialog(false); });
  };

  return (
    <div className={classes.root}>
      <Backdrop className={classes.backdrop} open={loading}><CircularProgress color="inherit" /></Backdrop>

      <Dialog open={openDialog} TransitionComponent={Transition} onClose={() => setOpenDialog(false)} maxWidth="lg" fullWidth>
        <div className={classes.dialogHeader}>
          <Typography style={{ fontWeight: 700, color: '#ff9800' }}>{selectedTitle}</Typography>
          <IconButton size="small" onClick={() => setOpenDialog(false)} style={{ color: '#fff' }}><CloseIcon /></IconButton>
        </div>
        <DialogContent style={{ textAlign: 'center', padding: '20px' }}>
          {imgLoading ? <CircularProgress style={{ color: '#FF9800' }} /> : <img src={selectedImg} alt="Preview" className={classes.previewImg} />}
        </DialogContent>
      </Dialog>
      
      <Card>
        <CardHeader title={"Malzeme İhtiyaç"}></CardHeader>
        <Divider />
        <CardContent>
            <div className={classes.searchBox}>
              <SearchIcon style={{ color: '#424242', opacity: 0.5 }} />
              <InputBase className={classes.inputInput} placeholder="Ara..." value={stateDurum} onChange={(e) => setStateDurum(e.target.value)} />
            </div>
            <div className={classes.filterScrollContainer}>
              {FILTER_OPTIONS.map((opt) => (
                <Chip 
                  key={opt.value} 
                  label={opt.label} 
                  icon={opt.icon}
                  onClick={() => setStateGun(opt.value)} 
                  className={clsx(classes.chip, stateGun === opt.value && classes.activeChip)} 
                />
              ))}
            </div>
        </CardContent>
      </Card>
      
      <br></br>
      
      <List disablePadding>
        {todosData.map((log) => (
          <Card key={log.FisNo} className={classes.card} elevation={0} style={{marginBottom: '10px'}}>
            <div className={classes.cardHeader} onClick={() => history.push(`/WorkOrder/${log.FisNo}/summary`)}>
              <Typography className={classes.customerName}>{log.Musteri}</Typography>
              <Typography variant="caption" style={{ color: '#424242', fontWeight: 600 }}>
                <span style={{ color: '#FF9800' }}>{log.FisNo}</span> - {log.TIME_SLOT1}
              </Typography>
            </div>
            {log.MALZEMELER.map((m, i) => (
              <div key={i} className={classes.materialItem}>
                <div className={classes.infoBox}><div className={classes.qtyText}>{m.ADET}</div></div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <Typography variant="subtitle2" style={{ fontWeight: 800 }}>{m.MALZEME_STOK_NO}</Typography>
                  <Typography variant="caption" color="textSecondary" noWrap style={{ display: 'block' }}>{m.ACIKLAMA}</Typography>
                </div>
                <IconButton className={classes.imgAction} onClick={(e) => { e.stopPropagation(); malzemeGosterMI(m.MALZEME_STOK_NO); }}><PhotoCameraIcon style={{ fontSize: 20 }} /></IconButton>
              </div>
            ))}
          </Card>
        ))}
      </List>
    </div>
  );
}

export default Todos;